import { Injectable } from "@angular/core";
import { BehaviorSubject } from 'rxjs';

@Injectable()

export class AppGlobal {

    logoHeader: string = '';
    logoHeaderForScroll: string = '';
    logoFooter: string = '';
    currentCurrency: BehaviorSubject<string> = new BehaviorSubject<string>('GBP');
    todaysRate: BehaviorSubject<object> = new BehaviorSubject<object>({});
    selectedCurrency: BehaviorSubject<string> = new BehaviorSubject<string>('GBP');
    showCurrencyConversion: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    ActivityApi: string = 'TMX';
    transferApi: string = 'TMX';
}